import React  from 'react';

const AppLoader = (props) => {
    return (
        <main className="loader d-flex px-3">
            <div className="loader-box d-flex justify-content-between align-items-center mx-auto w-100" style={props.noheight?{height:'50px'}:null}>
                <div className="loader-runner d-block"></div>
                <div className="loader-dot d-block"></div>
                <div className="loader-dot d-block"></div>
                <div className="loader-dot d-block"></div>
                <div className="loader-dot d-block"></div>
            </div>
        </main>
    )
}

export default AppLoader;
